module.exports = __webpack_public_path__ + "media/images/vp/icon.close.black-7d170ab99cb1c6449445f0a90b842ea8.svg";